<template>
  <div class="c-loader c-loader-center"></div>
</template>